const LOCALE_MAP = {
  ca: 'ca-ES',
  es: 'es-ES',
  en: 'en-US',
};

export function getLocale(lang) {
  return LOCALE_MAP[lang] || 'en-US';
}
